import classnames from 'classnames';
import React, { FunctionComponent } from 'react';
import './Horizontal.scss';

export interface HorizontalProps {
    'data-testid'?: string;
    className?: Parameters<typeof classnames>[0];
}

const Horizontal: FunctionComponent<HorizontalProps> = (props) => (
    <div
        className={classnames('eds-horizontal', props.className)}
        data-testid={props['data-testid']}
    >
        {props.children}
    </div>
);

export default Horizontal;
